<div class="drag-boundary absolute left-0 top-0 h-full w-full">
  <div
    cdkDrag
    class="absolute left-5 top-4 z-50 flex h-14 items-center justify-between rounded-lg bg-bo-black/70 px-2 backdrop-blur-lg"
    cdkDragBoundary=".drag-boundary"
  >
    <div class="z-50 flex h-full justify-center gap-5 p-2">
      <svg-icon
        class="cursor-move self-center fill-white/20"
        src="icons/grip.svg"
        [svgStyle]="{ 'height.px': 20 }"
      />
      @if (!appService.trackingMode()) {
        @if (!appService.demoMode()) {
          <svg-icon
            class="self-center fill-yellow-500"
            src="fa-icons/upload.svg"
            [svgStyle]="{ 'height.px': 20 }"
            (click)="uploader.click()"
            data-e2e="button-uploadVideo"
          />
        } @else {
          <svg-icon
            class="self-center fill-bo-red"
            src="fa-icons/folder-xmark.svg"
            [svgStyle]="{ 'height.px': 20 }"
            (click)="removeDemoMovie()"
          />
        }
        @if (mlTrackingService.isTrackingAvailable()) {
          <svg-icon
            class="self-center fill-orange-500"
            src="fa-icons/download.svg"
            [svgStyle]="{ 'height.px': 20 }"
            (click)="mlTrackingService.saveToFile()"
            data-e2e="button-uploadVideo"
          />
        }
      }
      @if (!appService.trackingMode()) {
        <svg-icon
          src="fa-icons/stethoscope.svg"
          class="self-center fill-lime-500"
          [svgStyle]="{ 'height.px': 20 }"
          (click)="mltracking.click()"
        />
      } @else {
        <svg-icon
          src="icons/stethoscope-close.svg"
          class="self-center fill-bo-red"
          [svgStyle]="{ 'height.px': 20 }"
          (click)="stopTrackingMode()"
        />
      }

      <input hidden type="file" #uploader (change)="selectDemoMovie($event)" />
      <input
        hidden
        type="file"
        #mltracking
        (change)="selectTracking($event)"
        webkitdirectory
        mozdirectory
      />

      @if (!appService.trackingMode()) {
        <svg-icon
          class="self-center fill-green-600"
          [ngClass]="{ 'fill-green-800': appService.showSceneLauncher() }"
          src="fa-icons/rocket-launch.svg"
          [svgStyle]="{ 'height.px': 20 }"
          (click)="
            appService.showSceneLauncher.set(!appService.showSceneLauncher())
          "
          data-e2e="button-sandbox"
        />
      }
      @if (appService.demoMode()) {
        @if (!appService.trackingMode()) {
          <svg-icon
            class="self-center fill-green-600"
            src="fa-icons/rotate-right.svg"
            [svgStyle]="{ 'height.px': 20 }"
            (click)="appService.replayVideo.emit()"
          />
        }
        @if (!appService.trackingMode()) {
          <svg-icon
            class="self-center fill-green-600"
            src="fa-icons/backward.svg"
            [svgStyle]="{ 'height.px': 20 }"
            (click)="appService.fastBackward.emit()"
          />
        }
        <svg-icon
          class="self-center fill-green-600"
          src="fa-icons/pause.svg"
          [svgStyle]="{ 'height.px': 20 }"
          (click)="appService.pauseVideo.emit()"
        />
        @if (!appService.trackingMode()) {
          <svg-icon
            class="self-center fill-green-600"
            src="fa-icons/forward.svg"
            [svgStyle]="{ 'height.px': 20 }"
            (click)="appService.fastForward.emit()"
          />
        }
      }
      <svg-icon
        class="self-center fill-blue-600"
        [ngClass]="{ 'fill-blue-800': appService.showConsole() }"
        src="fa-icons/square-terminal.svg"
        [svgStyle]="{ 'height.px': 20 }"
        (click)="appService.showConsole.set(!appService.showConsole())"
      />
      <svg-icon
        class="mr-2 self-center fill-purple-500"
        [ngClass]="{ 'fill-purple-700': appService.debugMode() }"
        src="fa-icons/bug.svg"
        [svgStyle]="{ 'height.px': 20 }"
        (click)="appService.debugMode.set(!appService.debugMode())"
      />
    </div>
  </div>
</div>
